// extracted by mini-css-extract-plugin
export default {"container":"gallery-layout_container","title":"gallery-layout_title","contentContainer":"gallery-layout_contentContainer","stickyHeader":"gallery-layout_stickyHeader"};